import React, { useState } from 'react';
import {
  View,
  Text,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
  SafeAreaView,
  Animated,
  Platform,
} from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { useTheme } from '../screens/ThemeContext';

const StatusBar = Platform.OS === 'web' ? () => null : require('react-native').StatusBar;

const FAQItem = ({ question, answer }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { theme } = useTheme();
  
  return (
    <View style={[styles.faqItem, { backgroundColor: theme.surface, borderColor: theme.border }]}>
      <TouchableOpacity 
        style={styles.questionContainer}
        onPress={() => setIsExpanded(!isExpanded)}
      >
        <View style={styles.questionContent}>
          <Text style={[styles.question, { color: theme.text }]}>{question}</Text>
          <MaterialCommunityIcons 
            name={isExpanded ? 'chevron-up' : 'chevron-down'} 
            size={24} 
            color={theme.primary}
          />
        </View>
      </TouchableOpacity>
      {isExpanded && (
        <View style={styles.answerContainer}>
          <Text style={[styles.answer, { color: theme.textSecondary }]}>{answer}</Text>
        </View>
      )}
    </View>
  );
};

const faqData = [
  {
    question: "Comment télécharger un document ?",
    answer: "Pour télécharger un document, accédez à la section souhaitée, sélectionnez le document et cliquez sur le bouton de téléchargement. Les documents sont disponibles hors ligne après téléchargement."
  },
  {
    question: "Comment fonctionne l'abonnement Premium ?",
    answer: "L'abonnement Premium vous donne accès à tous les documents sans limitation. Vous pouvez télécharger autant de documents que vous voulez et accéder aux fonctionnalités exclusives."
  },
  {
    question: "Comment contacter un centre de préparation ?",
    answer: "Dans la section 'Centres de Préparation', sélectionnez le centre qui vous intéresse et utilisez les boutons d'appel ou WhatsApp pour les contacter directement."
  },
  {
    question: "Les documents sont-ils disponibles hors ligne ?",
    answer: "Oui, une fois téléchargés, tous les documents sont disponibles hors ligne. Vous pouvez les consulter sans connexion internet dans la section 'Documents téléchargés'."
  },
  {
    question: "Comment réinitialiser mon mot de passe ?",
    answer: "Dans la section 'Paramètres', sélectionnez 'Sécurité' puis 'Changer le mot de passe'. Suivez les instructions pour réinitialiser votre mot de passe."
  },
  {
    question: "Quels sont les moyens de paiement acceptés ?",
    answer: "Nous acceptons les paiements via CAMPAY, qui supporte Orange Money, MTN Mobile Money et autres moyens de paiement mobiles au Cameroun."
  },
  {
    question: "Comment signaler un problème technique ?",
    answer: "Vous pouvez signaler un problème via la section 'Support' dans votre profil. Notre équipe technique vous répondra dans les plus brefs délais."
  },
  {
    question: "Les documents sont-ils à jour ?",
    answer: "Oui, nous mettons régulièrement à jour notre base de données avec les derniers sujets et corrigés disponibles pour chaque concours."
  }
];

export default function FAQScreen({ navigation }) {
  const { theme } = useTheme();

  return (
    <SafeAreaView style={[styles.safeArea, { backgroundColor: theme.background }]}>

      
      {/* Header */}
      <View style={[styles.header, { backgroundColor: theme.background }]}>
            <TouchableOpacity 
                  onPress={() => navigation.goBack()}
                  style={[styles.backButton, { backgroundColor: theme.surface, borderColor: theme.border }]}
                >
                  <MaterialCommunityIcons 
                    name="arrow-left" 
                    size={24} 
                    color={theme.primary} 
                  />
            </TouchableOpacity>
            <Text style={[styles.headerTitle, { color: theme.text }]}>
            Questions Fréquentes
            </Text>
      </View>

      {/* Search Header */}
      <View style={[styles.searchHeader, { backgroundColor: theme.primary }]}>
        <Text style={styles.searchHeaderText}>
          Comment pouvons-nous vous aider ?
        </Text>
        <Text style={styles.searchSubText}>
          Trouvez rapidement des réponses à vos questions
        </Text>
      </View>

      {/* FAQ List */}
      <ScrollView 
        style={[styles.container, { backgroundColor: theme.background }]}
        showsVerticalScrollIndicator={false}
      >
        <View style={styles.faqContainer}>
          {faqData.map((item, index) => (
            <FAQItem 
              key={index} 
              question={item.question} 
              answer={item.answer}
            />
          ))}
        </View>

        {/* Contact Support Section */}
        <View style={[styles.supportSection, { backgroundColor: theme.surface }]}>
          <Text style={[styles.supportTitle, { color: theme.text }]}>
            Vous n'avez pas trouvé votre réponse ?
          </Text>
          <TouchableOpacity 
            style={[styles.supportButton, { backgroundColor: theme.primary }]}
            onPress={() => navigation.navigate('SupportScreen')}
          >
            <MaterialCommunityIcons name="headphones" size={20} color="#fff" />
            <Text style={styles.supportButtonText}>
              Contacter le support
            </Text>
          </TouchableOpacity>
        </View>

        <View style={styles.bottomSpace} />
      </ScrollView>
      <View style={[styles.bottomSpace, {flex: 1}, { backgroundColor: theme.background }]} />
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(0, 0, 0, 0.1)',
  },
  backButton: {
    padding: 8,
    marginRight: 16,
    borderRadius: 12,
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: 'bold',
  },
  searchHeader: {
    padding: 20,
    alignItems: 'center',
  },
  searchHeaderText: {
    color: '#fff',
    fontSize: 22,
    fontWeight: 'bold',
    marginBottom: 8,
  },
  searchSubText: {
    color: '#fff',
    opacity: 0.9,
  },
  container: {
    flex: 1,
  },
  faqContainer: {
    padding: 20,
  },
  faqItem: {
    borderRadius: 12,
    marginBottom: 12,
    borderWidth: 1,
    overflow: 'hidden',
  },
  questionContainer: {
    padding: 16,
  },
  questionContent: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  question: {
    fontSize: 16,
    fontWeight: '600',
    flex: 1,
    marginRight: 16,
  },
  answerContainer: {
    padding: 16,
    paddingTop: 0,
  },
  answer: {
    fontSize: 14,
    lineHeight: 20,
  },
  supportSection: {
    margin: 20,
    padding: 20,
    borderRadius: 12,
    alignItems: 'center',
  },
  supportTitle: {
    fontSize: 16,
    fontWeight: '600',
    marginBottom: 15,
    textAlign: 'center',
  },
  supportButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 20,
    borderRadius: 25,
  },
  supportButtonText: {
    color: '#fff',
    fontWeight: '600',
    marginLeft: 8,
  },
  bottomSpace: {
    height: 40,
  },
});